import { SerpProgressAnalysisGq } from '../../../../graphql/projects/models/SerpProgressAnalysisGq';
import { TagGq } from '../../../../graphql/projects/models/TagGq';
export interface TagColor {
  darkStroke: string;
  darkFill: string;
  lightFill: string;
}

export interface TagData {
  color: TagColor;
  tag: TagGq;
  data: DataPoint[];
}

export interface DataPoint extends Partial<SerpProgressAnalysisGq> {
  scheduledTime: string;
}

export const tagColors: TagColor[] = [
  // Green
  {
    darkStroke: 'stroke-voxel-green-800/75',
    darkFill: 'fill-voxel-green-800/75',
    lightFill: 'fill-voxel-green-800/30',
  },
  {
    darkStroke: 'stroke-voxel-green-600/75',
    darkFill: 'fill-voxel-green-600/75',
    lightFill: 'fill-voxel-green-600/25',
  },
  {
    darkStroke: 'stroke-voxel-green-400/50',
    darkFill: 'fill-voxel-green-400/50',
    lightFill: 'fill-voxel-green-400/25',
  },
  // Blue
  {
    darkStroke: 'stroke-voxel-blue-600/75',
    darkFill: 'fill-voxel-blue-600/75',
    lightFill: 'fill-voxel-blue-600/25',
  },

  {
    darkStroke: 'stroke-voxel-blue-500/50',
    darkFill: 'fill-voxel-blue-500/50',
    lightFill: 'fill-voxel-blue-500/25',
  },
  {
    darkStroke: 'stroke-voxel-blue-400/50',
    darkFill: 'fill-voxel-blue-400/50',
    lightFill: 'fill-voxel-blue-400/25',
  },
  // Orange
  {
    darkStroke: 'stroke-voxel-orange-800/75',
    darkFill: 'fill-voxel-orange-800/75',
    lightFill: 'fill-voxel-orange-800/30',
  },
  {
    darkStroke: 'stroke-voxel-orange-600/75',
    darkFill: 'fill-voxel-orange-600/75',
    lightFill: 'fill-voxel-orange-600/25',
  },
  {
    darkStroke: 'stroke-voxel-orange-400/50',
    darkFill: 'fill-voxel-orange-400/50',
    lightFill: 'fill-voxel-orange-400/25',
  },
];
